import type { Configuration } from '@/config/types'
import type { PropertyIn, PropertyPath } from '@/scopes/common/domain/types'
import { getIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import * as React from 'react'

export const ConfigurationContext = React.createContext<Configuration | null>(null)

export const ConfigurationProvider = ConfigurationContext.Provider

export function useConfiguration<P extends PropertyPath<Configuration>>(fieldPath: P) {
  const configuration = useConfigurationFields()

  return getValueFromConfiguration(configuration, fieldPath)
}

function getValueFromConfiguration<C, P extends PropertyPath<C>>(fields: C, fieldPath: P): PropertyIn<C, P> {
  return getIn(fields, fieldPath) as PropertyIn<C, P>
}

function useConfigurationFields() {
  const fields = React.useContext(ConfigurationContext)
  if (!fields) {
    throw new Error('Attempted to use \'useConfiguration\' before initializing ConfigurationProvider.')
  }

  return fields
}
